import { useForm } from "react-hook-form";
import Input from "../../../../components/input/Input";
import { useCreateQuizQuestions } from "../hooks/useCreateQuizQuestion";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../../components/Button";
import Fileponds from "../../../../components/filepond/Filepond";
import { useState } from "react";

function CreateQuestion({ onCloseModal }) {
    const [questionImage, setQuestionImage] = useState();
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();
    const navigate = useNavigate();
    const { courseId, lectureId, itemId } = useParams();
    const {
        createQuizQuestion,
        isCreating,
        error: ApiError,
    } = useCreateQuizQuestions();

    function onSubmit({ question }) {
        //Send The Form Data To The API
        createQuizQuestion(
            {
                courseId,
                lectureId,
                itemId,
                question,
                image: questionImage ? questionImage[0]?.serverId : null,
            },
            {
                onSuccess: (data) => {
                    reset();
                    navigate(
                        `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${data?.data?.id}/options`
                    );
                    onCloseModal?.();
                },
            }
        );
    }
    return (
        <>
            <h3 className="py-5 text-xl text-center text-blue-color-primary">
                إنشاء سؤال
            </h3>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                <Input
                    label={"السؤال"}
                    name={"question"}
                    register={register("question", {
                        required: "يرجا إدخال أسم الكورس",
                    })}
                    error={
                        errors?.question?.message ||
                        ApiError?.response?.data?.errors?.question?.[0]
                    }
                    type="text"
                    size="fullWidth"
                    disabled={isCreating}
                />

                <p>إضافة صوره:</p>

                <Fileponds
                    filePath="images/questions/"
                    imageToken={setQuestionImage}
                />

                <div className="w-full pt-3">
                    <Button
                        type="primary"
                        className="w-full leading-8"
                        disabled={isCreating}
                    >
                        إنشاء سؤال
                    </Button>
                </div>
            </form>
        </>
    );
}

export default CreateQuestion;
